import Vue from 'vue'
import Vuex from 'vuex'
import ls from './LStorage'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
       obj:{},//直接跳转url,
       isWechat: 0,//0-不是
       token:''
    },
    mutations: {
        // 修改token
         setToken(state, bool) {
            state.token = bool;
            ls.setItem('token', bool);
        },
        //是否是微信
        setIsWeChat(state, value) {
            state.isWeChat = value;
        },
        //微信跳转url
       setObj(state,obj) {
           state.obj =obj;
           ls.setItem('obj', obj)
       },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js